export const NAMESPACE = "PortalProfileInfoContacts";

export const CONTACT_ACTIONS = {
  DELETE_GROUP: "deleteGroup",
  DELETE: "delete",
  OPEN: "open",
  SEND_EMAIL: "sendEmail",
  REMOVE_OR_PRIMARY: "removeOrSetPrimary",
  ACCESS_PORTAL: "accessPortal",
  REMOVE_ACCESS_PORTAL: "removeAccessPortal",
  ADD_CONTACT: "addContact"
};

export const PAYLOAD = {
  payload: {
    contacts: [
      {
        id: "2a3f3bf7-ca67-4eb6-8caa-3e61eab475be",
        contact_id: "9d91329d-ed72-4e1b-93d6-567cc786a4eb",
        first_name: "Andras",
        last_name: "Hortinson",
        photo_url: null,
        name: "Andras Hortinson",
        email: "dev@lennd.com",
        is_primary: true,
        account_user_id: 1,
        can_login: true,
        actions: {
          type: "general-actions",
          value: [
            {
              id: "open",
              name: "Open"
            },
            {
              id: "send-email",
              name: "Send Email"
            },
            {
              id: "primary-contact",
              name: "Remove from Primary Contact"
            },
            {
              id: "portal-access",
              name: "Give Portal Login access"
            },
            {
              id: "remove-from-group",
              name: "Remove From Group"
            },
            {
              id: "delete",
              name: "Delete Contact"
            }
          ]
        }
      },
      {
        id: "890a2ddb-ce71-4954-abb9-3a263b90621e",
        contact_id: "4cc000cf-1043-4e74-a4a5-e70e8d611639",
        first_name: "Pablo",
        last_name: "Hiyano",
        photo_url: null,
        name: "Pablo Hiyano",
        email: "pablo.hiyano@whiteprompt.com",
        is_primary: true,
        account_user_id: 92467,
        can_login: true,
        actions: {
          type: "general-actions",
          value: [
            {
              id: "open",
              name: "Open"
            },
            {
              id: "send-email",
              name: "Send Email"
            },
            {
              id: "primary-contact",
              name: "Remove from Primary Contact"
            },
            {
              id: "portal-access",
              name: "Give Portal Login access"
            },
            {
              id: "remove-from-group",
              name: "Remove From Group"
            },
            {
              id: "delete",
              name: "Delete Contact"
            }
          ]
        }
      }
    ],
    pagination: {
      page: 0,
      pageSize: 10,
      total: 2,
      pages: 1
    },
    counters: {
      all: "2"
    }
  }
};
